import Tekmirio from '.';
import { useState, useEffect } from 'react';
import { fetchCollectionsOptions, fetchErgoTypesOptions, fetchTekmirioTypesOptions } from '../../../lib/fetchers';
import i18n from '../../../i18n';
import { GetSortOrder } from '../../../lib/helperFuncs';
import { useTranslation } from 'react-i18next';

function SmartTekmirio() {
  const { t } = useTranslation();
  const [sullogesOptions, setSullogesOptions] = useState<any>([]);
  const [ergoTypeOptions, setErgoTypeOptions] = useState<any>([]);
  const [tekmirioTypeOptions, seTtekmirioTypeOptions] = useState<any>([]);


  useEffect(() => {
    const fetching = async () => {
      
      const [collectionsOptions, ergoTypeOptions, tekmirioTypeOptions] = await Promise.all([
        fetchCollectionsOptions(), fetchErgoTypesOptions(), fetchTekmirioTypesOptions()
      ]);
      
      const _collectionsOptions = collectionsOptions?.data.map((x:any) => {
        return {value: x['o:id'], key: i18n.language === 'el'
          ? x['o:title']
          : x['collections:collectionsEnTitle']?.[0]?.['@value']};
      });
      const _ergoTypeOptions = ergoTypeOptions?.['o:terms'].map((x:any) => {return {key: t(x), value: x};});
      const _tekmirioTypeOptions = tekmirioTypeOptions?.['o:terms'].map((x:any) => {return {key: t(x), value: x};});

      setSullogesOptions(i18n.language === 'en'
        ? _collectionsOptions.sort(GetSortOrder('key'))
        : _collectionsOptions.sort((a: any,b: any) => a.key.localeCompare(b.key, 'el')));
      setErgoTypeOptions(i18n.language === 'en'
        ? _ergoTypeOptions.sort(GetSortOrder('key'))
        : _ergoTypeOptions.sort((a: any,b: any) => a.key.localeCompare(b.key, 'el')));
      seTtekmirioTypeOptions(i18n.language === 'en'
        ? _tekmirioTypeOptions.sort(GetSortOrder('key'))
        : _tekmirioTypeOptions.sort((a: any,b: any) => a.key.localeCompare(b.key, 'el')));

    };

    fetching();

  }, []);


  return <Tekmirio
    ergoTypeOptions={ergoTypeOptions}
    sullogesOptions={sullogesOptions}
    tekmirioTypeOptions={tekmirioTypeOptions}
  />;
}

export default SmartTekmirio;